import styled from '@emotion/styled';
import { Flex } from 'antd';
import { Link } from 'react-router-dom';

export const CustomLink = styled(Link)`
  color: #4d4d4d;
  text-decoration: none;
  line-height: 1;
  margin-bottom: 24px;

  &:hover {
    text-decoration: underline;
  }
`;

export const FormContainer = styled(Flex)`
  max-width: 30%;
  margin: 0 auto;
  min-height: 70vh;

  @media (max-width: 768px) {
    max-width: 60%;
  }

  @media (max-width: 480px) {
    max-width: 90%;
    padding: 0 1rem;
    min-height: 80vh;
  }
`;

export const ButtonGroup = styled(Flex)`
  gap: 1rem;
  align-self: center;

  @media (max-width: 480px) {
    width: 100%;
    justify-content: center;
  }
`;
